import Image from 'next/image';
import type { ReactNode } from 'react';
import { IconBrandTelegram, IconBrandTiktokFilled, IconBrandYoutubeFilled, IconWorld } from '@tabler/icons-react';
import { cn } from '@/lib/utils';

const brandIcons: Record<string, string> = {
  Facebook: '/assets/icons/brand-facebook.svg',
  Instagram: '/assets/icons/brand-instagram.svg',
  LinkedIn: '/assets/icons/brand-linkedin.svg',
};

const TABLER_CLASS_NAME = 'size-[80%]';

function renderIcon(label: string, size: number): ReactNode {
  const src = brandIcons[label];
  if (src) {
    return <Image src={src} width={size} height={size} alt='' aria-hidden className='size-full' />;
  }

  switch (label) {
    case 'Сайт':
      return <IconWorld size={size} stroke={1.75} className={cn(TABLER_CLASS_NAME, 'text-text-primary-day')} />;
    case 'YouTube':
      return <IconBrandYoutubeFilled size={size} color='#FF0000' className='size-[75%]' />;
    case 'TikTok':
      return <IconBrandTiktokFilled size={size} color='#000000' className='size-[65%]' />;
    case 'Telegram':
      return <IconBrandTelegram size={size} stroke={1.75} color='#229ED9' className={TABLER_CLASS_NAME} />;
    default:
      return null;
  }
}

export function SocialIcon({ label, className = 'size-5' }: { label: string; className?: string }) {
  const icon = renderIcon(label, 24);
  if (!icon) {
    return null;
  }

  return <span className={cn('inline-flex shrink-0 items-center justify-center', className)}>{icon}</span>;
}
